import React from 'react';
import { View } from 'react-native';

import Entry from 'app/src/styles/mobileTable';
import { datetimeShort } from 'app/src/utils/formatting';
import { Link } from 'app/src/utils/routing';

const MobileNonAdrPreRegistrationsRow = ({ entry, columns }) => {
  const actionColumn = columns[columns.length - 1];

  return (
    <Entry.Container>
      <Link to={`/dealers/${entry.id}`}>
        <Entry.Title>
          {entry.name}
        </Entry.Title>
      </Link>
      <Entry.Text>
        {entry.licenses.map(license => license.licenseString).join(', ')}
      </Entry.Text>
      {entry.activeMember && (<Entry.Text>OIADA Member</Entry.Text>)}
      <Entry.Text>
        {entry.preRegistrationSubscriptionStatus || 'No Subscription'}
      </Entry.Text>
      <Entry.Text>
        {entry.nonAdrTagCount} Third-party Temp Tags Registered
      </Entry.Text>
      <Entry.Text>
        Last Third-party Registration{' '}
        {datetimeShort(entry.lastNonAdrTagRegisteredAt)}
      </Entry.Text>
      {actionColumn.content({ entry })}
    </Entry.Container>
  );
};

export default MobileNonAdrPreRegistrationsRow;
